'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$() {
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$ as $c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$ };
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$ as $h_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$ };
$h_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$.prototype.hashCode__I = (function() {
  return 469875631;
});
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$.prototype.toString__T = (function() {
  return "Aborted";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$.prototype.productPrefix__T = (function() {
  return "Aborted";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$, "app.api.DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$", ({
  Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$: 1,
  Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$ as $d_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$ };
var $n_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$;
function $m_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$() {
  if ((!$n_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$)) {
    $n_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$ = new $c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$();
  }
  return $n_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$;
}
export { $m_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$ as $m_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$ };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$-Provided-E-P-S-Code$-Aborted$.js.map
